<template>
    <div class="navbar hidden-xs hidden-md" v-if="!$root.mobile.isMobile">
        <div class="navbar-inner">
            <div class="left">
                <a v-if="!$root.$route.meta.backButton" v-on:click="$root.menu()" class="link icon-only panel-open" data-panel="left">
                    <i class="las la-bars"></i>
                </a>
                <a v-if="$root.$route.meta.backButton == true" v-on:click="$root.back()" class="link icon-only panel-open" data-panel="left">
                    <i class="las la-arrow-left"></i>
                </a>                
            </div>
            <div class="title sliding">
                <img src="static/images/logo.png" style="height: 40px;">
            </div>
            <div class="right">
                <a class="link icon-only panel-open" style="opacity: 0; pointer-events: none;">                    
                    <i class="las la-bars"></i>
                </a>
            </div>

            <div class="subnavbar" v-if="($root.$route.name != 'Conta' && $root.user.tipo != 'empresa') || $root.user.tipo == 'empresa' || ($root.user.tipo == 'prestador' && $root.user.empresaCod)">
                <div class="subnavbar-inner">
                    <div class="tabbar">
                        <div class="toolbar-inner">
                            <a v-on:click="$root.go('Conta')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Conta'}">
                                <img class="icone-toolbar" v-if="$root.$route.name == 'Conta'" src="static/images/icons/home-active.png" alt="">
                                <img class="icone-toolbar" v-if="$root.$route.name != 'Conta'" src="static/images/icons/home.png" alt="">
                                Minha conta
                            </a>
                            <a v-if="$root.user.tipo != 'empresa'" v-on:click="$root.go('Pacientes')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Pacientes'}">
                                <img class="icone-toolbar" v-if="$root.$route.name == 'Pacientes'" src="static/images/icons/users-active.png" alt="">
                                <img class="icone-toolbar" v-if="$root.$route.name != 'Pacientes'" src="static/images/icons/users.png" alt="">
                                Pacientes
                            </a>
                            <a v-if="$root.user.tipo != 'empresa'" v-on:click="$root.go('Pedidos')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Pedidos'}">
                                <img class="icone-toolbar" v-if="$root.$route.name == 'Pedidos'" src="static/images/icons/calendar-active.png" alt="">
                                <img class="icone-toolbar" v-if="$root.$route.name != 'Pedidos'" src="static/images/icons/calendar.png" alt="">
                                Pedidos
                            </a>
                            <a v-if="$root.user.tipo == 'empresa'" v-on:click="$root.go('PrestadoresEmpresas')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'PrestadoresEmpresas'}">
                                <img class="icone-toolbar" v-if="$root.$route.name == 'PrestadoresEmpresas'" src="static/images/icons/settings-active.png" alt="">
                                <img class="icone-toolbar" v-if="$root.$route.name != 'PrestadoresEmpresas'" src="static/images/icons/settings.png" alt="">
                                Gerenciar profissionais
                            </a>                            
                            <a v-if="$root.user.tipo == 'prestador' && !$root.user.empresaCod" v-on:click="$root.go('Agendas')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Agendas'}">
                                <img class="icone-toolbar" v-if="$root.$route.name == 'Agendas'" src="static/images/icons/settings-active.png" alt="">
                                <img class="icone-toolbar" v-if="$root.$route.name != 'Agendas'" src="static/images/icons/settings.png" alt="">
                                Opções de atendimento
                            </a>
                            <a v-if="$root.user.tipo == 'admin'" v-on:click="$root.go('Configuracoes')" class="tab-link" v-bind:class="{'tab-link-active': $root.$route.name == 'Configuracoes'}">
                                <img class="icone-toolbar" v-if="$root.$route.name == 'Agendas'" src="static/images/icons/settings-active.png" alt="">
                                <img class="icone-toolbar" v-if="$root.$route.name != 'Agendas'" src="static/images/icons/settings.png" alt="">
                                Configurações
                            </a>                            
                            <a v-on:click="$root.logout()" class="tab-link">
                                <i class="las la-sign-out-alt mr-5" style="font-size: 26px;"></i>
                                Sair
                            </a>                                
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
export default {
    name: 'Top',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .subnavbar .tab-link.tab-link-active {
        background: #efefef;
        color: #333 !important;        
    }

    .icone-toolbar {
        height: auto;
        width: 26px;
        margin-right: 5px;
        z-index: 1;
        transition: all 400ms ease-in-out;
        filter: invert(20%) sepia(92%) saturate(3275%) hue-rotate(341deg) brightness(96%) contrast(95%);
        -webkit-filter: invert(20%) sepia(92%) saturate(3275%) hue-rotate(341deg) brightness(96%) contrast(95%);
    }

    .tab-link-active .icone-toolbar {
        filter: invert(59%) sepia(33%) saturate(193%) hue-rotate(179deg) brightness(96%) contrast(90%);
        -webkit-filter: invert(59%) sepia(33%) saturate(193%) hue-rotate(179deg) brightness(96%) contrast(90%);
    }
</style>



// WEBPACK FOOTER //
// src/components/Top.vue